(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteTranslation', PublicSiteTranslation);

    PublicSiteTranslation.$inject = ['$resource'];

    function PublicSiteTranslation ($resource) {
        var resourceUrl =  'api/public-site-translations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
